export var cgtAsset = 
{
    description: "",
    marketValue: 0.00,
    baseCost: 0.00,
    capitalGain: 0.00,
    bequethedToSpouse: 0.00,
    residueTospouse: 0.00,
    netGain: 0.00
}

export var incomeNeedAtDeath=
{
    need: "",
    dependant: "",
    mounhtlyAmount: 0.00,
    seaceAge: 0,
    anualIncrease: 0.00
}

export var incomeProvisionAtDeath=
{
    income: "",
    dependant: "",
    mounhtlyAmount: 0.00,
    seaceAge: 0,
    anualIncrease: 0.00
}

export var assetsDisabilityCgt = 
{
    marketValue: 0.00,
    baseCost: 0.00,
    capitalGain: 0.00
}

export var disabilityIncomeNeed = 
{
    need: "",
    mounhtlyAmount: 0.00,
    seaceAge: 0,
    anualIncrease: 0.00
}

export var disabilityIncomeProvision = 
{
    income: "",
    mounhtlyAmount: 0.00,
    seaceAge: 0,
    anualIncrease: 0.00
}
export class fnaResult
{
     fna =
    {
        balanceSheet:
        {
            assets: [],
            netAssetsClient: 0.00,
            netAssetsSpouse: 0.00,
            policies: [],
            netPoliciesClient: 0.00,
            netPoliciesSpouse: 0.00,
            liabilities: [],
            netLiabilitiesClient: 0.00,
            netLiabilitiesSpouse: 0.00,
            netTotalAssetsClient : 0.00,
            netTotalAssetsSpouse : 0.00
        },
    
        executorFees:
        {
            percentageApplicable: 0.00,
            vat: 0.00,
            pToEstate: 0.00,
            executorFee: 0.00
        },
    
        cgt:
        {
            pResidence:
            {
                description: "",
                marketValue: 0.00,
                baseCost: 0.00,
                capitalGain: 0.00,
                bequethedToSpouse: 0.00,
                residueTospouse: 0.00,
                spouseCapitalGain: 0.00,
                netGain: 0.00
            },
            cgtAssets: [],
            netCgtMarketValue: 0.00,
            netClientsBaseCost: 0.00,
            netClientsCapitalGain:0.00,
            netClientsCapitalGainDisplay:0.00,
            netCashBequestTospouse: 0.00,
            netResidueTospouse: 0.00,
            netSpouseCapitalGain: 0.00,
            capitalGain: 0.00,
            minuspResidence:
            {
                primaryResidenceExclusion: 0.00,
                primaryResidence: 0.00,
                primaryResidenceLossExclusion: 0.00,
                primaryResidenceLoss: 0.00,
                netExclusion: 0.00
            },
            netMinusExlusion: 0.00,
            minusspouseRollOver:
            {
                portionBequethedTospouse: 0.00,
                portionResidueTospouse: 0.00,
                netRollOver: 0.00
            },
            netMinusRollOver: 0.00,
            minusPreviousLoss: 0.00,
            netMinusPreviousLoss: 0.00,
            minusExclusionAtDeath: 0.00,
            netMinusExlusionAtDeath: 0.00,
            netCgt: 0.00,
            marginalTax: 0.00,
            inclusionRate: 0.00,
            cgtPayable: 0.00
        },
    
        estateDuty:
        {
            assets:
            {
                netAssets: 0.00,
                netFarms: 0.00,
                netDeemedAssets: 0.00,
                netPoliciesOnLife: 0.00,
                netPoliciesWithChash: 0.00,
                netAccrualClaim: 0.00,
                netEstateAssets: 0.00
            },
            deductions:
            {
                netLiabilities: 0.00,
                netAdministration: 0.00,
                netFuneral: 0.00,
                netMastersFee: 0.00,
                netExectutorsFee: 0.00,
                netCapitalGainTax: 0.00,
                netTransferCosts: 0.00,
                netBequethedAssets: 0.00,
                netCashBequestTospouse: 0.00,
                netCashBequestToCharity: 0.00,
                netResidueTospouse: 0.00,
                netPoliciesToSpouse: 0.00,
                netAccrualClaim: 0.00,
                netDeductions: 0.00
            },
            netEstate: 0.00,
            minusRebate: 0.00,
            minusRebateFromPreviousSpouse: 0.00,
            taxableEstate: 0.00,
            estateDutyPayable: 0.00,
            apportionmentOfEstate: 0.00,
            payableByOther: 0.00,
            payableByEstate: 0.00
        },
    
        liquidity:
        {
           cashNeeded:
           {
            netCgt: 0.00,
            netLiabilities: 0.00,
            netExectutorsFee: 0.00,
            netEstateDuty: 0.00,
            netOtherCosts: 0.00,
            netBequethedLiquidAssets: 0.00,
            netCashBequests: 0.00,
            netAccrualClaim: 0.00,
            netCashNeeded: 0.00
           },
           cashAvailable:
           {
               cash: 0.00,
               netLiquidInvestments: 0.00,
               netCashAssets: 0.00,
               netPolicies: 0.00,
               netCashAvailable: 0.00
           },
           cash: 0.00
        },
    
        accrual:
        {
            current:
            {
                valueOfAssets:
                {
                    client: 0.00,
                    spouse: 0.00
                },
                valueOfPolicies: 0.00,
                minusLiabilities:
                {
                    client: 0.00,
                    spouse: 0.00
                },
                netValue:
                {
                    client: 0.00,
                    spouse: 0.00
                }
            },
            assetValueExcluded:
            {
                client: 0.00,
                spouse: 0.00
            },
            atMarriage:
            {
                valueANC:
                {
                    client: 0.00,
                    spouse: 0.00
                },
                valueCpiAdjusted:
                {
                    client: 0.00,
                    spouse: 0.00
                }
            },
            netAccrual:
            {
                client: 0.00,
                spouse: 0.00
            },
            claimAgainstSpouse: 0.00,
            clainBySpouse: 0.00
        },
    
        residue:
        {
            totalAssets: 0.00,
            minus: 0.00,
            policies: 0.00,
            bequestsToOther: 0.00,
            cashBequestsToOther: 0.00,
            bequestsToSpouse: 0.00,
            cashBequestsToSpouse: 0.00,
            liabilities: 0.00,
            costs: 0.00,
            accrualClaimBySpouse: 0.00,
            residueBeforeEstateDuty: 0.00,
            minusEstateDuty: 0.00,
            residue: 0.00
        },
    
        deathProvision:
        {
            liquidity: 0.00,
            surplusToOther: 0.00,
            capitalNeed: 0.00,
            netNeed: 0.00,
            provision:
            {
                policies: 0.00,
                cashToSpouse: 0.00,
                capitalLiquidity: 0.00
            },
            needAtDeath: [],
            incomeProvision: [],
            capitalProvisioning: [],
            monthsProvisioned: 0
        },
    
        disabilityCgt:
        {
            assets: [],
            netAssetMarketValue: 0.00,
            netAssetBaseCost: 0.00,
            netAssetCapitalGain: 0.00,
            deductions:
            {
                primaryResidence: 0.00,
                smallBusiness: 0.00,
                exclusion: 0.00,
                previousCgtLoss: 0.00
                
            },
            netCgt: 0.00,
            marginalTax: 0.00,
            inclusionRate: 0.00,
            cgtPayable: 0.00
        },
    
        disabilityLiquidity:
        {
            cashNeeded: 0.00,
            cgt: 0.00,
            liabilities: 0.00,
            cashAvailable:
            {
                cash: 0.00,
                liquidInvestments: 0.00,
                assetstToCash: 0.00,
                policies: 0.00,
                cededPolicies: 0.00,
                netCash: 0.00
            },
            netCash: 0.00
        },
    
        disabilityProvision:
        {
            surplus: 0.00,
            capitalNeed: 0.00,
            capitalProvision: 0.00,
            disabilityIncomeNeed: [],
            disabilityIncomeProvision: []
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/FNA_result_vars.js